module.exports = __webpack_public_path__ + "static/media/empty08_invoices_anim.7f10fa4f.svg";